import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

export default function LostDealModal({ lossReasons, onConfirm, onCancel }) {
  const [motivo, setMotivo] = useState('');
  const [notas, setNotas] = useState('');

  const handleConfirm = () => {
    if (!motivo) return;
    onConfirm(motivo, notas);
  };

  return (
    <div data-testid="lost-deal-modal" className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header-lost">
          <AlertTriangle size={24} color="#dc2626" />
          <h2>Cierre Perdido</h2>
        </div>
        <p className="modal-desc">Este lead será marcado como perdido. Selecciona el motivo obligatorio.</p>

        <div className="modal-field">
          <label>Motivo de pérdida *</label>
          <select
            data-testid="loss-reason-select"
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
          >
            <option value="">Seleccionar motivo...</option>
            {lossReasons.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>

        <div className="modal-field">
          <label>Notas adicionales</label>
          <textarea
            data-testid="loss-notes-input"
            value={notas}
            onChange={e => setNotas(e.target.value)}
            placeholder="Detalles sobre la pérdida..."
            rows={3}
          />
        </div>

        <div className="modal-actions">
          <button data-testid="cancel-lost-deal" className="btn-cancel" onClick={onCancel}>Cancelar</button>
          <button
            data-testid="confirm-lost-deal"
            className="btn-danger"
            onClick={handleConfirm}
            disabled={!motivo}
          >
            Confirmar Pérdida
          </button>
        </div>
      </div>
    </div>
  );
}
